// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1meOa","rootSmall":"AddTileButton_rootSmall__nrU9N"};